export enum FieldsName {
  playlistLink = 'playlistLink',
}

export type FieldsType = {
  [FieldsName.playlistLink]: string;
};
